<template>
      <div>
         <div class="row">
          <div v-for="(det, index) in dataTabla" class="col-sm-12 col-lg-12">
            <div class="borderY" v-if="det.estado!='9'">
              <div class="card-body px-5 mx-2">
                <div class="row py-1">
                  <div class="col-6">
                    <div class="d-flex flex-column">
                      <p class="card-text mb-1 font-weight-bold">{{ det.producto.nombre }}</p>
                      <span class="text">
                        <i class="fa fa-check-circle mr-0"></i>
                        Cantidad: <b>{{ det.cantidad_contada }}</b>
                      </span>
                      <span class="text">
                        <i class="fas fa-cloud"></i>
                        Teórica: {{ det.existencia_al_asignar }}
                      </span>
                      <span class="text">
                        <i class="fa fa-clock mr-0"></i>
                        Contado: {{ det.fecha_creacion | moment("DD/MM/YYYY HH:mm:ss") }}
                      </span>
                      <div class="d-flex flex-column" v-if="det.fecha_vencimiento">
                        <div class="mb-0">
                          <span class="medium d-block">
                          <i class="fa fa-calendar mr-1"></i>
                          Vence: {{ det.fecha_vencimiento | moment("DD/MM/YYYY") }}
                        </span>
                        <span v-if="dataTabla.fecha_finalizacion && tipo != 'R'" class="medium d-block">
                          <i class="fa fa-cubes mr-1"></i>
                          Teórica: {{ det.existencia_al_asignar }}
                        </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="!bloqueado" class="col-6 d-flex align-content-center justify-content-end" :data-id="det.id">
                    <button class="btn btn-lg btn-danger" @click="idAnularDetalle(det.id)" >
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </template>
<script>
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import ProductoSelectComponentV2 from "@/components/commons/ProductoSelectComponentV2";

import Vue from "vue";
Vue.use(require("vue-moment"));

export default {
  components: {
    UsuarioEnTablaComponent,
    ProductoSelectComponentV2,
  },
  props: ["dataTabla", "tipo", "bloqueado"],
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      posiciones: [],
      searchtext: "",
      filtro_estado: "",
      currentDet: "",
      type: "",
      current: {
        producto: "",
        cantidad: 0,
        posicion: "",
        fecha_vencimiento: "",
      },
    };
  },
  watch: {},
  computed: {},
  mounted() {},
  methods: {
    idAnularDetalle(id) {
      this.$emit('id-anular-detalle', id);
    }
  },
};
</script>